import { isValid } from '../cpf'

export default function cpf() {
  return this.test('cpf', 'cpfInvalid', (value) => isValid(value))
}
